import * as BABYLON from 'babylonjs';

class MaterialManager
{
    constructor() {
        this.materials = new Map();
        this.scene = undefined;
        this.time = 0;
    }

    initialize( scene ) {
        this.scene = scene;
        this.registerMaterial( "info", this.createInfo2Material());
    }

    update() {
        this.materials.get("info").setFloat("time", this.time);
        this.time += 0.02;
    }

    registerMaterial( name, material ) {
        this.materials.set( name, material );
    }

    get( name ) {
        if( this.materials.has( name )){
            return this.materials.get( name );
        }
        return undefined;
    }
    
    createInfoMaterial() {
        BABYLON.Effect.ShadersStore["infoVertexShader"]=
                "precision highp float;\r\n"+
                "precision highp int;\r\n"+

                "uniform mat4 worldViewProjection;\r\n"+

                "attribute vec3 position;\r\n"+
                "attribute vec2 uv;\r\n"+

                "varying vec2 vUV;\r\n"+

                "void main() {\r\n"+

                "    vUV = uv;\r\n"+
                "    gl_Position = worldViewProjection * vec4( position, 1.0 );\r\n"+

                "}\r\n";

                BABYLON.Effect.ShadersStore["infoFragmentShader"]=                
                "precision highp float;\r\n"+
                "precision highp int;\r\n"+

                "varying vec2 vUV;\r\n"+
                "uniform float time;\r\n"+

                "const float F3 = 0.3333333;\r\n"+
                "const float G3 = 0.1666667;\r\n"+

                "const float waverSpeed = 0.47451395;\r\n"+
                "const float turbulence = 2.6210;\r\n"+
                "const float flashSpeed = 0.0;\r\n"+
                "const float electricitySpeed = 0.271695;\r\n"+
                "const float contrast = 19.07;\r\n"+
                "const float thickness = 0.8;\r\n"+
                "const float phaseSpeed = 10.0;\r\n"+

                "const vec3 color = vec3(100.0, 0.0, 0.0);\r\n"+

                "vec3 random3(vec3 c) {\r\n"+
                "    float j = 4096.0*sin(dot(c,vec3(17.0, 59.4, 15.0)));\r\n"+
                "    vec3 r;\r\n"+
                "    r.z = fract(512.0*j);\r\n"+
                "    j *= .125;\r\n"+
                "    r.x = fract(512.0*j);\r\n"+
                "    j *= .125;\r\n"+
                "    r.y = fract(512.0*j);\r\n"+
                "    return r-0.5;\r\n"+
                "}\r\n"+

                "float simplex3d(vec3 p) {\r\n"+
                "    vec3 s = floor(p + dot(p, vec3(F3)));\r\n"+
                "    vec3 x = p - s + dot(s, vec3(G3));\r\n"+
                "    vec3 e = step(vec3(0.0), x - x.yzx);\r\n"+
                "    vec3 i1 = e*(1.0 - e.zxy);\r\n"+
                "    vec3 i2 = 1.0 - e.zxy*(1.0 - e);\r\n"+
                "    vec3 x1 = x - i1 + G3;\r\n"+
                "    vec3 x2 = x - i2 + 2.0*G3;\r\n"+
                "    vec3 x3 = x - 1.0 + 3.0*G3;\r\n"+
                "    vec4 w, d;\r\n"+
                "    w.x = dot(x, x);\r\n"+
                "    w.y = dot(x1, x1);\r\n"+
                "    w.z = dot(x2, x2);\r\n"+
                "    w.w = dot(x3, x3);\r\n"+
                "    w = max(0.6 - w, 0.0);\r\n"+
                "    d.x = dot(random3(s), x);\r\n"+
                "    d.y = dot(random3(s + i1), x1);\r\n"+
                "    d.z = dot(random3(s + i2), x2);\r\n"+
                "    d.w = dot(random3(s + 1.0), x3);\r\n"+
                "    w *= w;\r\n"+
                "    w *= w;\r\n"+
                "    d *= w;\r\n"+

                "    return dot(d, vec4(52.0));\r\n"+
                "}\r\n"+

                "// Add or remove octaves for more granular noise\r\n"+
                "float noise(vec3 m) {\r\n"+
                "    return 0.5333333 * simplex3d( m )\r\n"+
                "        + 0.2666667 * simplex3d( 2.0 * m )\r\n"+
                "        + 0.1333333 * simplex3d( 4.0 * m )\r\n"+
                "        + 0.0666667 * simplex3d( 8.0 * m );\r\n"+
                "}\r\n"+

                "void main(void) {\r\n"+
                "    vec2 uvScaled = vUV.xy * 2.0 - 1.0;\r\n"+
                "    uvScaled.y += waverSpeed * 4.0 * ( -0.5 + mod( time * waverSpeed, 1.0 ) );\r\n"+
                "    vec3 p3 = vec3( vUV.xy * turbulence, time * electricitySpeed );\r\n"+

                "    float simplexNoise = noise( vec3( p3 * 12.0 + 12.0 ) );\r\n"+

                "    float t = clamp( ( uvScaled.x * -uvScaled.x * 0.16 ) + 0.15, 0.0, 1.0 );\r\n"+
                "    float y = abs( simplexNoise * -t + uvScaled.y ) * ( 0.6 + sin( time * flashSpeed ) );\r\n"+

                "    float g = pow( y, thickness );\r\n"+

                "    float pixel = pow(1.0 - g, contrast);\r\n"+
                "    float alpha = round(pixel + 0.4);\r\n"+
                "    gl_FragColor = vec4( pixel * color, alpha );\r\n"+
                "}\r\n";	

        let shaderMaterial = new BABYLON.ShaderMaterial("shader", this.scene, {
            vertex: "info",
            fragment: "info",
        },
        {
            attributes: ["position", "normal", "uv"],
            uniforms: ["world", "worldView", "worldViewProjection", "view", "projection"],
            needAlphaBlending: true
        });	
        shaderMaterial.setFloat("time", 0);
        shaderMaterial.setVector3("cameraPosition", BABYLON.Vector3.Zero());
        shaderMaterial.backFaceCulling = false;

        return shaderMaterial;			
    }

    createInfo2Material() {
        BABYLON.Effect.ShadersStore["info2VertexShader"]=
                "precision highp float;\r\n"+
                "precision highp int;\r\n"+

                "uniform mat4 worldViewProjection;\r\n"+

                "attribute vec3 position;\r\n"+
                "attribute vec2 uv;\r\n"+

                "varying vec2 vUV;\r\n"+

                "void main() {\r\n"+

                "    vUV = uv;\r\n"+
                "    gl_Position = worldViewProjection * vec4( position, 1.0 );\r\n"+

                "}\r\n";

                BABYLON.Effect.ShadersStore["info2FragmentShader"]=                
                "precision mediump float;\r\n"+
                "uniform float time;\r\n"+
                "varying vec2 vUV;\r\n"+
                "void main( void ) {\r\n"+
                //"    vec2 position = ( gl_FragCoord.xy );\r\n"+  
                "    vec2 uvScaled = vUV.xy * 100.0 - 50.0;\r\n"+  
                "    vec2 position = ( uvScaled.xy );\r\n"+  
                "    float color = 0.0;\r\n"+
                "    float alpha = max( 1.0 - 4.0 * sqrt((vUV.x-0.5)*(vUV.x-0.5) + (vUV.y-0.5)*(vUV.y-0.5)), 0.0);\r\n"+
                "    for(float i = 0.0; i < 1.0; i++){\r\n"+
                "        float v = 10.0;\r\n"+
                "        float dx1 = pow(position.x,2.0);\r\n"+
                "        float dy1 = pow(position.y,2.0);\r\n"+
                "        float r1 = sqrt(dx1+dy1);\r\n"+
                "        color += sin( r1 * 0.3 - time*v);\r\n"+
                "    }\r\n"+
                "    gl_FragColor = vec4( vec3( color, color, color), alpha * color );\r\n"+
                "}\r\n";	

        let shaderMaterial = new BABYLON.ShaderMaterial("shader", this.scene, {
            vertex: "info2",
            fragment: "info2",
        },
        {
            attributes: ["position", "normal", "uv"],
            uniforms: ["world", "worldView", "worldViewProjection", "view", "projection"],
            needAlphaBlending: true
        });	
        shaderMaterial.setFloat("time", 0);
        shaderMaterial.setVector3("cameraPosition", BABYLON.Vector3.Zero());
        shaderMaterial.backFaceCulling = false;

        return shaderMaterial;			
    }    
}

const instance = new MaterialManager();
//Object.freeze(instance);

export default instance;
